export enum QrDownloadFileTypes {
  PNG = "png",
  SVG = "svg",
  JPG = "jpg",
  JPEG = "jpeg",
}
